import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11 * (props.wx ?? 1)}
    height={36 * (props.hx ?? 1)}
    viewBox="0 0 11 36"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.204 26.822c-.14-.775-.298-1.47-.511-2.036-.133-.353-.24-.702-.263-1.079-.139-2.225-.57-5.304-.731-8.22-.195-3.504-.456-6.684-1.362-10.64C5.888 2.887 5.305 1.007 4.8 1c-.506-.006-.934 1.86-.966 4.163-.067 4.745-.407 7.78-.757 10.912-.312 2.797-.668 5.131-.847 6.932-.084.84-.165 1.12-.318 1.497q-.08.198-.205.582c-.241.732-1.249 6.272-.322 7.374.615.731 1.285.941 2.257 1.545.421.262 1.424.802 2.043.801.733 0 1.441-.529 1.99-.868.641-.398 1.064-.82 1.298-1.224.722-1.243.63-3.67.231-5.892z"
    />
  </svg>
);
export default SvgNormal;
